import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { tripsAPI } from "components/Apis/trips";

export const fetchTrips = createAsyncThunk(
    "trips/fetchTrips",
    async ({ page = 1, page_size = 10, filters = {}, append = false } = {}, { rejectWithValue }) => {
        try {
            const response = await tripsAPI.getTrips(page, page_size, filters);
            return { response, page, page_size, filters, append };
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const getResultsPayload = (payload) => {
    if (payload && Array.isArray(payload.results)) {
        return {
            trips: payload.results,
            count: payload.count ?? payload.results.length,
            next: payload.next ?? null,
            previous: payload.previous ?? null,
        };
    }
    if (Array.isArray(payload)) {
        return {
            trips: payload,
            count: payload.length,
            next: null,
            previous: null,
        };
    }
    return {
        trips: [],
        count: 0,
        next: null,
        previous: null,
    };
};

const tripsSlice = createSlice({
    name: "trips",
    initialState: {
        trips: [],
        count: 0,
        next: null,
        previous: null,
        page: 1,
        pageSize: 10,
        filters: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTrips.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTrips.fulfilled, (state, action) => {
                state.loading = false;
                const { response, page, page_size, filters, append } = action.payload;
                const normalized = getResultsPayload(response);
                state.trips = append
                    ? state.trips.concat(normalized.trips)
                    : normalized.trips;
                state.count = normalized.count;
                state.next = normalized.next;
                state.previous = normalized.previous;
                state.page = page;
                state.pageSize = page_size;
                state.filters = filters || {};
            })
            .addCase(fetchTrips.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default tripsSlice.reducer;
